var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"main-logo d-flex align-center"},[_c('BaseIcon',{attrs:{"name":"logo"}})],1),_c('BaseIcon',{staticClass:"mobile-logo",attrs:{"name":"logo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }